<template>
    <div class="card share-sidebar">
        <header class="card-header">
            <p class="card-header-title">Share:</p>
            <a href="#" class="card-header-icon" aria-label="more options">
              <span class="icon ">
                <i class="fas fa-share-alt"></i>
              </span>
            </a>
        </header>
        <div class="card-content">
            <div class="content center">
                <p class="buttons">
                    <social-sharing @open="open" :networks="overrideNetworks" :url="location" inline-template>
                        <div>
                            <network network="print" class="button">
                                <span class="icon">
                                  <i class="fas fa-print"></i>
                                </span>
                            </network>
                            <network network="share" class="button">
                                <span class="icon">
                                    <i class="far fa-share-square"></i>
                                </span>
                            </network>
                            <network network="facebook" class="button">
                                <span class="icon" style="color: #4267b2">
                                    <i class="fab fa-facebook-square"></i>
                                </span>
                            </network>
                            <network network="whatsapp" class="button">
                                <span class="icon" style="color: #25D366">
                                   <i class="fab fa-whatsapp-square"></i>
                                </span>
                            </network>
                        </div>
                    </social-sharing>
                </p>
            </div>
        </div>
        <input type="hidden" id="locationLink" v-model="location">
    </div>
</template>

<script>
    export default {
        props: ['lot'],
        data () {
            return {
                location: window.location.href,
                overrideNetworks: {
                    print: {
                        sharer: '',
                        type: ''
                    },
                    share: {
                        sharer: '',
                        type: ''
                    }
                }
            }
        },
        methods: {
            open(element) {
                if (element === 'print') {
                    window.print();
                }
                if (element === 'share') {
                    let locationLinkToCopy = document.querySelector('#locationLink')
                    locationLinkToCopy.setAttribute('type', 'text')
                    locationLinkToCopy.select()

                    try {
                        var successful = document.execCommand('copy')
                        alert('Link was copied!')
                    } catch (err) {
                        alert('Oops, unable to copy')
                    }

                    locationLinkToCopy.setAttribute('type', 'hidden')
                    window.getSelection().removeAllRanges()
                }
            },
        },
    }
</script>

<style scoped>
    .card-content {
        padding: .75em !important;
    }
    .facebook-icon {
        color: #4267b2!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Lot/ShareBox.vue